import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FlexBox, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';

import Footer from '@fo-pages/home/footer/Footer';
import MemberTop from '@fo-pages/member/MemberTop';

/*
  ECMJ PRG_EXON_02_01 (옥진호)
  CookieGateLayout 페이지 배치를 (MemberTop, 컨텐트영역, Footer)로 구성함.
 */
const CookieGateLayout = ({ children }) => {
  return (
    <StyledFlexBoxColumn width={'100%'}>
      <MemberTop />
      <FlexBox align-items={'flex-start'} style={{ flex: 1 }}>
        {children}
      </FlexBox>
      <Footer showInquiry={false} />
    </StyledFlexBoxColumn>
  );
};

CookieGateLayout.propTypes = {
  children: PropTypes.node,
};

const StyledFlexBoxColumn = styled(FlexBoxColumn)`
  min-width: 1630px;
  min-height: 100vh;
`;

export default CookieGateLayout;
